import { createSlice } from '@reduxjs/toolkit';
const languageSlice = createSlice({
    name: 'language',
    initialState: {
        locale: null,
        ownLanguages: null,
    },
    reducers: {
        setLocale: (state, action) => {
            state.locale = action.payload;
        },
        setOwnLanguages: (state, action) => {
            state.ownLanguages = action.payload;
        }
    },
});

export const { setLocale, setOwnLanguages } = languageSlice.actions;
export const selectLocale = (state) => state.language.locale;
export const selectOwnLanguages = (state) => state.language.ownLanguages;
export default languageSlice.reducer;
